import { useMutation, useQueryClient } from 'react-query'
import { useParams, useSearchParams } from 'react-router-dom'

import { QUERY_KEYS } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'
import { IAccountUpdateUserRolesDto } from 'src/types'

const useAccountChangeUserRole = () => {
  const [, setSearchParams] = useSearchParams()
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: IAccountUpdateUserRolesDto) => {
      if (!accountId) return null

      return await accountsService.updateAccountUsersRole(accountId, dto)
    },
    {
      onSuccess: (data) => {
        if (!data) return

        setSearchParams((params) => {
          data.verify_transfer_ownership_token &&
            params.set('verify_transfer_ownership_token', data.verify_transfer_ownership_token)
          return params
        })
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_USERS, accountId])
      },
    },
  )
}

export { useAccountChangeUserRole }
